import { BigNumber } from "ethers";
import { isNativeGasQuoteToken } from "../config/chains";
import { AllCollaterals, IsUSDC } from "../constants/addresses";
import { ChainIdEnum } from "../enums/chain";
import { depositMax } from "./amount/max/depositMax";
import { MaxResult } from "./amount/max/types";

/** Gas kept back on a chain whose own gas token IS the quote asset (Arc). */
export const NATIVE_QUOTE_GAS_RESERVE = "1";

export interface DepositMaxArgs {
  balance?: BigNumber;
  nativeBalance?: BigNumber;
  decimals: number;
  chainId?: ChainIdEnum;
  asset: AllCollaterals;
}

/**
 * The most that may be deposited, or the reason it is not known.
 *
 * The resolver (P2 `depositMax`) holds back the gas reserve where the deposit
 * asset IS the gas token, and distinguishes "balance not read yet"
 * (`balance_unknown`) and "wallet is empty" (`zero_balance`) from a maximum of
 * 0 — which is what MAX used to fill in for all three.
 */
export const depositMaxResult = ({
  balance,
  nativeBalance,
  decimals,
  chainId,
  asset,
}: DepositMaxArgs): MaxResult =>
  depositMax({
    walletUnits: balance ? balance.toBigInt() : undefined,
    nativeUnits: nativeBalance ? nativeBalance.toBigInt() : undefined,
    decimals,
    isNativeGasToken: Boolean(
      chainId && isNativeGasQuoteToken(chainId) && IsUSDC(asset)
    ),
    gasReserve: NATIVE_QUOTE_GAS_RESERVE,
    unit: String(asset),
  });

/** The same figure as plain decimal text, or `undefined` when there is none. */
export function getMaxDepositAmount(args: DepositMaxArgs): string | undefined {
  const max = depositMaxResult(args);
  return max.ok ? max.max : undefined;
}
